import { Typography, Box } from "@mui/material";

const NotFound = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        gap: 2,
      }}>
      <Typography variant="h4">404: The page you are looking for isn’t here</Typography>
      <Typography variant="subtitle2">Page not found or you don&apos;t have permission to access this page.</Typography>
    </Box>
  );
};

export default NotFound;
